<template>
  <div class="search" :style="{'margin-top': marginTop + 'px'}">
    <input @keydown.enter="searchTrigger" class="search_input" type="text" name="search" value="" v-model="searchText" placeholder="検索：ミルトプラス">
    <div class="search_btn" @click="search()"><img src="../../../assets/images/common/search.png" alt=""></div>
  </div>
</template>

<script>
export default {
  props: ['marginTop'],
  data() {
    return {
      searchText: '',
    }
  },
  methods: {
    searchTrigger(e) {
      if (event.keyCode !== 13) return
      this.search();
    },
    search() {
      // 検索に未入力の場合と検索したテキストが同じ場合遷移させない
      if(this.searchText == '' || this.searchText == this.$route.query.search) return;
      this.$router.push(
        {
          name: 'ColumnList',
          query: { resultType: 'search', search: this.searchText },
          }).catch(err => {});
    },
  },
  // watch: {
  //     $route(to, from) {
  //       console.log(to);
  //       console.log(from);
  //       if(to.query.search != from.query.search || to.query.resultType != from.query.resultType) {
  //         this.$router.push(to).catch(err => {
  //           console.log(err);
  //         })
  //       }
  //     },
  //   },
}
</script>

<style lang="css" scoped>
.search {
  border: 1px solid  #C9C9C9;
  border-radius: 10px;
  display: flex;
  overflow: hidden;
  /* position: relative; */
}
.search::after {
  /* background-image: url(../../assets/images/common/search.png);
  background-repeat: no-repeat;
  background-size: contain;
  content: '';
  position: absolute;
  right: 8px;
  bottom: 0;
  top: 0;
  margin: auto;
  width: 25px;
  height: 25px; */
}
.search_input {
  border: none;
  font-size: 16px;
  padding: 16px 8px 16px 16px;
  width: 88%;
}
.search_btn {
  align-items: center;
  display: flex;
  padding-right: 16px;
  width: 12%;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/column/SearchInput.vue